import Component from '../core/Component'
import EventBus from '../core/EventBus'
import Scroll from '../services/Scroll'

const STATES = {
    ACTIVE: 'is-active',
    CURRENT: 'is-current',
    HIDDEN: 'is-hidden',
    HOVERED: 'is-hovered',
    NOTIFY: 'is-notify',
    REVEAL: 'is-revealed',
    SHADOW_LEFT: 'is-shadowLeft',
    SHADOW_RIGHT: 'is-shadowRight',
}

const TIMING = {
    FINISH_TO_SCROLL: 500,
    HOVER_TO_HIDE: 2700,
    NAVIGATION_TO_HIDE: 999999,
    NOTIFY_TO_HIDE: 4000,
}

export default class FloatingNavigation extends Component {
    constructor(element) {
        super(element)

        this.timer = null

        this.ref = {
            hover: null,
            links: [],
            list: null,
            notify: null,
            notifyText: null,
            layout: null,
        }

        this.state = {
            clickedId: null,
            currentElement: null,
            currentHoverElement: null,
            currentHoverEvent: null,
            currentSection: 'hero',
            cursor: null,
            hoverId: null,
            listScrollLeft: 0,
            notify: true,
            notifyStatus: false,
            open: false,
            parentBounding: null,
            timerNotify: null,
        }

        this.timers = {
            close: null,
            hoverClose: null,
        }
    }

    prepare() {
        Scroll.on('scroll', this.handleScroll)

        this.element.addEventListener('mouseenter', this.handleMouseEnter)
        this.element.addEventListener('mouseleave', this.handleMouseLeave)
        this.ref.list.addEventListener('scroll', this.handleListScroll)

        this.state.cursor = document.querySelector('.Cursor')

        this.state.parentBounding = this.element.getBoundingClientRect()
        this.element.addEventListener('transitionend', (event) => {
            if (event.target !== this.element) {
                return
            }

            this.state.open = this.is(STATES.REVEAL)
            if (this.state.open) {
                this.render()
            }
        })

        this.ref.links.forEach((link) => {
            link.addEventListener('mouseenter', this.handleItemMouseEnter)
            link.addEventListener('click', this.handleItemClick)
        })
        this.links = this.ref.links.reduce((acc, element) => {
            const key = element.href.split('#')[1]
            acc[key] = element
            return acc
        }, {})

        const observer = new IntersectionObserver(
            (entries) => {
                const section = entries.find((entry) => entry.isIntersecting)?.target.id
                if (section) {
                    this.setCurrent(section)
                }
            },
            {
                rootMargin: '-50% 0% -50% 0%',
            }
        )

        observer.observe(document.getElementById('kontakt'))
        observer.observe(document.getElementById('klienti'))
        observer.observe(document.getElementById('solutions'))
        observer.observe(document.getElementById('oceneni'))
        observer.observe(document.getElementById('references'))
        observer.observe(document.getElementById('hero'))

        this.handleMouseEnter()
        this.handleListScroll()
        this.ref.hover.classList.add(STATES.REVEAL)
    }

    destroy() {
        this.ref.list.removeEventListener('scroll', this.handleListScroll)
        Scroll.off('scroll', this.handleScroll)
        Object.values(this.timers).forEach((timer) => clearTimeout(timer))
    }

    handleScroll = (data) => {
        this.renderScroll(data)
    }

    handleListScroll = (event) => {
        this.state.listScrollLeft = this.ref.list.scrollLeft
        const scrollLeftMax = this.ref.list.scrollWidth - this.ref.list.clientWidth

        if (this.state.listScrollLeft > 0) {
            this.ref.layout.classList.add(STATES.SHADOW_LEFT)
        } else {
            this.ref.layout.classList.remove(STATES.SHADOW_LEFT)
        }

        if (this.state.listScrollLeft < scrollLeftMax) {
            this.ref.layout.classList.add(STATES.SHADOW_RIGHT)
        } else {
            this.ref.layout.classList.remove(STATES.SHADOW_RIGHT)
        }
    }

    handleMouseEnter = () => {
        if (this.state.notify) {
            this.state.cursor.classList.remove(STATES.ACTIVE)
            clearTimeout(this.timers.close)
            clearTimeout(this.timers.hoverClose)
            this.state.open = true
            this.render()
        }
    }

    handleMouseLeave = () => {
        if (this.state.notify) {
            this.state.cursor.classList.add(STATES.ACTIVE)
            this.state.hoverId = null
            this.render()
            this.timers.close = setTimeout(() => {
                this.state.open = false
                this.render()
            }, TIMING.NAVIGATION_TO_HIDE)
        }
    }

    handleItemMouseEnter = (event) => {
        this.ref.hover.classList.add(STATES.REVEAL)
        const id = event.target.href.split('#')[1]
        if (id) {
            this.state.hoverId = id
            this.render()
        }
    }

    handleItemClick = () => {
        const id = event.target.href.split('#')[1]

        if (id) {
            this.state.clickedId = id
            this.render()
        }
        this.render()
    }

    setCurrent(id) {
        this.state.currentSection = id
        if (this.state.clickedId === id) {
            this.state.clickedId = null
        }
        this.render()
    }

    renderScroll({ offset, limit }) {
        const y = offset.y

        if (y > 200 && limit.y - 200 > y) {
            this.element.style.transform = 'translate(-50%, -195px)'
        } else if (limit.y - 200 < y) {
            this.element.style.transform = `translate(-50%, 300px)`
        } else {
            this.element.style.transform = `translate(-50%, ${-y}px)`
        }

        if (y >= limit.y) {
            if (this.state.notify) {
                this.notify('A dál už nic fakt nenajdete, tak hybaj hore.')
            }
            if (!this.state.open) {
                this.state.notify = false
            }
        }
    }

    notify = (string) => {
        clearTimeout(this.state.timerNotify)

        if (!this.state.open) {
            if ((this.state.notify = true)) {
                this.ref.notifyText.innerHTML = string
                const { width } = this.ref.notifyText.getBoundingClientRect()
                this.element.style.width = `${width}px`
                this.ref.hover.classList.remove(STATES.REVEAL)
                this.element.classList.add(STATES.NOTIFY)
                this.state.notifyStatus = false

                this.state.timerNotify = setTimeout(() => {
                    this.state.notify = true
                    this.element.classList.remove(STATES.NOTIFY)
                    this.element.style.width = `75px`
                    this.state.notifyStatus = true
                }, TIMING.NOTIFY_TO_HIDE)
            }
        }
    }

    render() {
        const sectionId = this.state.clickedId || this.state.currentSection
        const box = this.links[sectionId].getBoundingClientRect()
        const elementBox = this.element.getBoundingClientRect()

        Object.entries(this.links).forEach(([key, link]) => {
            const id = this.state.clickedId || this.state.currentSection
            link.classList.toggle(STATES.CURRENT, key === id)
            if (key === id) {
                this.state.currentElement = link
            }
        })

        this.element.classList.toggle(STATES.REVEAL, this.state.open)

        const elementShift = box.left - elementBox.left + this.state.listScrollLeft

        this.ref.hover.style.width = `${box.width}px`
        this.ref.hover.style.transform = `translateX(${elementShift}px)`

        this.state.currentElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
    }
}
